// eslint-disable-next-line
export const LOCALE_PREFIX = 'components.TableCell.components.Signals'
